<!-- 
    가장 최근의 SnapshotData를 기준으로 Type별 Status의 현황을 보여주는 그래프

 -->

<template>
    <b-row class="w-100 d-flex justify-content-center align-items-center" :class="isFlexible ? 'h-100' : 'h-80'" style="margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
             
        <div v-if="bugSeries && !thereIsNoData" class="bug-report-graph h-100" style="flex:3; position: relative;" :style="isFlexible ? 'padding: 10px 0;' : 'padding: 0;'">
            <apexchart id="bugChart"
            width="100%" height="100%" ref="bugChart" 
            :options="chartOptions" 
                :series="bugSeries" />
        </div>
        <div v-if="issueSeries && !thereIsNoData" class="bug-report-graph h-100" style="flex:3; padding: 10px 0px; position: relative;">
            <apexchart id="issueChart"
            width="100%" height="100%" ref="issueChart" 
            :options="issueChartOptions" 
                :series="issueSeries" />
        </div>
        <div v-if="riskSeries && !thereIsNoData" class="bug-report-graph h-100" style="flex:3; padding: 10px 0px; position: relative;">
            <apexchart id="ristChart"
            width="100%" height="100%" ref="ristChart" 
            :options="riskChartOptions" 
                :series="riskSeries" />
        </div>
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {getLastSnapshotDate} from '@/components/chatter/util/graphUtils';
export default {
    name: 'BugReportGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts
    },
    mounted() {
        // this.setSeries();
        // this.setLabels();
        
        this.currentChatterData = this.dashboardData.currentChatter;
        if(this.currentChatterData.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.reloadGraph();
        }
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                if(this.isFlexible) {
                    
                    this.bugSeries = [];
                    this.chartOptions.labels = [];
                    this.reloadGraph();
                }
            }
        },
    },
    data() {
        return {
            label: ['Critical', 'Major', 'Minor', 'Trivial', 'N/A'],
            filename : '버그 현황',
            thereIsNoData: false,
            loading:false,
            lastSnapshotDate : '',
            columnNames: [],
            currentChatterData: [],
            snapshotData :[],
            bugSeries: '',
            issueSeries:'',
            riskSeries: '',
            chartOptions: {
                chart: {
                    height:'80%',
                    type: "donut",
                    events: {
                        mounted: () => {this.loading = false;}
                    },
                    stacked: false,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: this.filename,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: this.filename,
                            },
                            png: {
                                filename: this.filename,
                            }
                        },
                    },
                },
                title: {
                    text: this.isFlexible ? "Bug" : "",     // title에는 show 속성이 없어서 직접 조건 처리
                    align: "center",
                    offsetX: 0,
                    offsetY: 300,
                },
                colors: ['#FF0000', '#FF6767', '#FFB5B5', '#FFD4D4', '#FFE8E8'],
                labels : [],
                dataLabels:{
                    enabled:this.isFlexible,
                },
                plotOptions: {
                    pie: {
                        customScale: 0.9,
                        expandOnClick: false,
                        donut: {
                            size: '60%',
                            labels: {
                                show: this,
                                value: {
                                    show: true,
                                    color: '#2E2E38',
                                    fontSize: this.isFlexible ? '32px' : '20px',
                                    fontWeight: '700',
                                    offsetY: this.isFlexible ? 10 : 0,
                                    formatter: val => this.formatNumber(val, 0)
                                },
                                total: {
                                    show: true,
                                    label: 'Total',
                                    color: '#747480',
                                    fontSize: this.isFlexible ? '18px' : '14px',
                                    formatter: chart => {
                                        const total = chart.config.series.reduce((a, b) => a + b, 0)
                                        return this.formatNumber(total, 0)
                                    }
                                },
                            },
                        },
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                // stroke: {
                //     width: [4, 4, 4, 4],
                //     curve: 'straight',
                // },
                // xaxis: {
                //     categories: [],
                //     show:this.isFlexible,
                //     labels: {
                //         show:this.isFlexible
                //     }
                // },
                // yaxis: {
                //     labels: {
                //         show:this.isFlexible
                //     }
                // },
                legend: {
                    show: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: this.isFlexible ? 7 : 3,
                    fontSize: this.isFlexible ? '14px' : '12px'
                },
                grid :{
                    show:false
                }
            },
            issueChartOptions: {
                chart: {
                    height:'80%',
                    type: "donut",
                    events: {
                        mounted: () => {this.loading = false;}
                    },
                    stacked: false,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: this.filename,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: this.filename,
                            },
                            png: {
                                filename: this.filename,
                            }
                        },
                    },
                },
                title: {
                    text: this.isFlexible ? "Issue" : "",     // title에는 show 속성이 없어서 직접 조건 처리
                    align: "center",
                    offsetX: 0,
                    offsetY: 300,
                },
                colors: ['#FF0000', '#FF6767', '#FFB5B5', '#FFD4D4', '#FFE8E8'],
                labels : [],
                dataLabels:{
                    enabled:this.isFlexible,
                },
                plotOptions: {
                    pie: {
                        customScale: 0.9,
                        expandOnClick: false,
                        donut: {
                            size: '60%',
                            labels: {
                                show: this,
                                value: {
                                    show: true,
                                    color: '#2E2E38',
                                    fontSize: this.isFlexible ? '32px' : '20px',
                                    fontWeight: '700',
                                    offsetY: this.isFlexible ? 10 : 0,
                                    formatter: val => this.formatNumber(val, 0)
                                },
                                total: {
                                    show: true,
                                    label: 'Total',
                                    color: '#747480',
                                    fontSize: this.isFlexible ? '18px' : '14px',
                                    formatter: chart => {
                                        const total = chart.config.series.reduce((a, b) => a + b, 0)
                                        return this.formatNumber(total, 0)
                                    }
                                },
                            },
                        },
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                // stroke: {
                //     width: [4, 4, 4, 4],
                //     curve: 'straight',
                // },
                // xaxis: {
                //     categories: [],
                //     show:this.isFlexible,
                //     labels: {
                //         show:this.isFlexible
                //     }
                // },
                // yaxis: {
                //     labels: {
                //         show:this.isFlexible
                //     }
                // },
                legend: {
                    show: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: this.isFlexible ? 7 : 3,
                    fontSize: '14px'
                },
                grid :{
                    show:false
                }
            },
            riskChartOptions: {
                chart: {
                    height:'80%',
                    type: "donut",
                    events: {
                        mounted: () => {this.loading = false;}
                    },
                    stacked: false,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: this.filename,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: this.filename,
                            },
                            png: {
                                filename: this.filename,
                            }
                        },
                    },
                },
                title: {
                    text: this.isFlexible ? "Risk" : "",     // title에는 show 속성이 없어서 직접 조건 처리
                    align: "center",
                    offsetX: 0,
                    offsetY: 300,
                },
                colors: ['#FF0000', '#FF6767', '#FFB5B5', '#FFD4D4', '#FFE8E8'],
                labels : [],
                dataLabels:{
                    enabled:this.isFlexible,
                },
                plotOptions: {
                    pie: {
                        customScale: 0.9,
                        expandOnClick: false,
                        donut: {
                            size: '60%',
                            labels: {
                                show: this,
                                value: {
                                    show: true,
                                    color: '#2E2E38',
                                    fontSize: '32px',
                                    fontWeight: '700',
                                    offsetY: 10,
                                    formatter: val => this.formatNumber(val, 0)
                                },
                                total: {
                                    show: true,
                                    label: 'Total',
                                    color: '#747480',
                                    fontSize: '18px',
                                    formatter: chart => {
                                        const total = chart.config.series.reduce((a, b) => a + b, 0)
                                        return this.formatNumber(total, 0)
                                    }
                                },
                            },
                        },
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                // stroke: {
                //     width: [4, 4, 4, 4],
                //     curve: 'straight',
                // },
                // xaxis: {
                //     categories: [],
                //     show:this.isFlexible,
                //     labels: {
                //         show:this.isFlexible
                //     }
                // },
                // yaxis: {
                //     labels: {
                //         show:this.isFlexible
                //     }
                // },
                legend: {
                    show: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: 7,
                    fontSize: '14px'
                },
                grid :{
                    show:false
                }
            },
            tableData: [],
            statusInfo : {
                'TO_DO' : true, 
                'IN_PROGRESS' : true, 
                'DONE' : true, 
                'CLOSED' : false,
                'CANCELLED' : false,
                'CONFIRMED' : false,
                'APPROVED' : false
            }
        }
    },
    methods: {
        // 09-21 사용하지 않으나 우선 지우지 않고 주석
        // getLabelArray() {
        //     const lastSnapshotDate = getLastSnapshotDate(this.snapshotData);
        //     this.lastSnapshotDate = lastSnapshotDate;

        //     let priorityArray = [];
            
        //     // 마지막 snapshot에 등록되어 있는 priority label로 지정
        //     this.snapshotData.forEach(data => {
        //         if(
        //             data.date === lastSnapshotDate && 
        //             data.type === 'bug' && this.statusInfo[data.status]) {
        //                 priorityArray.push(data.priority);
        //         }
        //     });

        //     let labelPriorityArray = [...new Set(priorityArray)]; // 라벨데이터
            
        //     if(priorityArray.length <= 0) {
        //         this.thereIsNoData = true;
        //     }

        //     return labelPriorityArray;
        // },

        countData(dataArray) {

            let countMap = new Map();
            this.label.forEach(level => {
                countMap.set(level, 0);
            });

            let riskCountMap = new Map();
            this.label.forEach(level => {
                riskCountMap.set(level, 0);
            });

            let issueCountMap = new Map();
            this.label.forEach(level => {
                issueCountMap.set(level, 0);
            });

            // let snapshotDate = this.lastSnapshotDate;
            // if(this.isFlexible && this.filters.from != '') {
            //     snapshotDate = this.filters.from;
            // }

            let typeArray = ['bug', 'risk', 'issue'];

                // levelOptions: [
                //   {value: "", text: ""},
                //   {value: "3", text: "Critical"},
                //   {value: "2", text: "Major"},
                //   {value: "1", text: "Minor"},
                //   {value: "0", text: "Trivial"},
                // ],

            dataArray.forEach(data => {
                // 가장 최신의 snapshotData만 합산
                
                // 상세 페이지 일때 issue, risk 그래프까지 그림
                if(this.isFlexible) {
                    if(this.statusInfo[data.status] && 'bug' === data.type) {
                        // TODO
                        // 이후 0,1,2로 들어간 Priority 컬럼의 값이 문자열로 변경되면 아래 코드도 함께 변경해줘야함
                        switch (data.level) {
                            case 'Critical':
                                countMap.set('Critical', countMap.get('Critical') + 1);
                                break;

                            case 'Major':
                                countMap.set('Major', countMap.get('Major') + 1);
                                break;
                        
                            case 'Minor':
                                countMap.set('Minor', countMap.get('Minor') + 1);
                                break;
                            case 'Trivial':
                                countMap.set('Trivial', countMap.get('Trivial') + 1);
                                break;
                            default:
                                countMap.set('N/A', countMap.get('N/A') + 1);
                        }
                    }

                    if(this.statusInfo[data.status] && data.type === 'risk') {
                    // TODO
                    // 이후 0,1,2로 들어간 Priority 컬럼의 값이 문자열로 변경되면 아래 코드도 함께 변경해줘야함
                        switch (data.level) {
                            case 'Critical':
                                riskCountMap.set('Critical', riskCountMap.get('Critical') + 1);
                                break;

                            case 'Major':
                                riskCountMap.set('Major', riskCountMap.get('Major') + 1);
                                break;
                        
                            case 'Minor':
                                riskCountMap.set('Minor', riskCountMap.get('Minor') + 1);
                                break;
                            case 'Trivial':
                               riskCountMap.set('Trivial', riskCountMap.get('Trivial') + 1);
                                break;
                            default:
                                riskCountMap.set('N/A', riskCountMap.get('N/A') + 1);
                        }
                    }

                    if(this.statusInfo[data.status] && data.type === 'issue') {

                    // TODO
                    // 이후 0,1,2로 들어간 Priority 컬럼의 값이 문자열로 변경되면 아래 코드도 함께 변경해줘야함
                        switch (data.level) {
                            case 'Critical':
                                issueCountMap.set('Critical', issueCountMap.get('Critical') + 1);
                                break;

                            case 'Major':
                                issueCountMap.set('Major', issueCountMap.get('Major') + 1);
                                break;
                        
                            case 'Minor':
                                issueCountMap.set('Minor', issueCountMap.get('Minor') + 1);
                                break;
                            case 'Trivial':
                                issueCountMap.set('Trivial', issueCountMap.get('Trivial') + 1);
                                break;
                            default:
                                issueCountMap.set('N/A', issueCountMap.get('N/A') + 1);
                        }
                    }
                } else {
                    if(this.statusInfo[data.status] && typeArray.includes(data.type)) {
                        // TODO
                        // 이후 0,1,2로 들어간 Priority 컬럼의 값이 문자열로 변경되면 아래 코드도 함께 변경해줘야함
                        switch (data.level) {
                            case 'Critical':
                                countMap.set('Critical', countMap.get('Critical') + 1);
                                break;

                            case 'Major':
                                countMap.set('Major', countMap.get('Major') + 1);
                                break;
                        
                            case 'Minor':
                                countMap.set('Minor', countMap.get('Minor') + 1);
                                break;
                            case 'Trivial':
                                countMap.set('Trivial', countMap.get('Trivial') + 1);
                                break;
                            default:
                                countMap.set('N/A', countMap.get('N/A') + 1);
                        }
                    }
                }
            });

            
            let bugSeries = [];

            this.label.forEach(key =>{
                bugSeries.push(countMap.get(key));
            });

            this.bugSeries = bugSeries;

            if(this.isFlexible) {
                let riskSeries = [];
                let issueSeries = [];

                this.label.forEach(key =>{
                    riskSeries.push(riskCountMap.get(key));
                    issueSeries.push(issueCountMap.get(key));
                });

                this.riskSeries = riskSeries;
                this.issueSeries = issueSeries;
            }

            
            return bugSeries;
        },

        visualizeGraph() {
            let dataArray = this.currentChatterData;

            if(this.isFlexible) {
                let L1 = this.filters.L1;
                let L2 = this.filters.L2;
                let L3 = this.filters.L3;
                let JOB = this.filters.JOB;
                let PRIORITY = this.filters.PRIORITY;
                let TYPE = this.filters.TYPE;
                let BUSINESS_CATEGORY = this.filters.BUSINESS_CATEGORY;

                // None 값을 ""로 변경
                L1 = L1.map(value => value === "None" ? "" : value);
                L2 = L2.map(value => value === "None" ? "" : value);
                L3 = L3.map(value => value === "None" ? "" : value);
                JOB = JOB.map(value => value === "None" ? "" : value);
                PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
                TYPE = TYPE.map(value => value === "None" ? "" : value);
                BUSINESS_CATEGORY = BUSINESS_CATEGORY.map(value => value === "None" ? "" : value);

                dataArray = dataArray.filter(item => {

                    return (
                        L1.includes(item.l1) &&
                        L2.includes(item.l2) &&
                        L3.includes(item.l3) &&
                        JOB.includes(item.job) &&
                        PRIORITY.includes(item.priority) &&
                        TYPE.includes(item.type) && 
                        BUSINESS_CATEGORY.includes(item.businessCategory)
                    );
                });
            }

            // let labelArray = this.getLabelArray();
            
            let series = this.countData(dataArray);

            // this.bugSeries = series;
            // labelArray = labelArray.map(item => item == '' ? 'None' : item);
            // this.label = labelArray;
            this.setLabels();
        },

        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        setLabels() {
            this.chartOptions.labels = this.label;
            this.issueChartOptions.labels = this.label;
            this.riskChartOptions.labels = this.label;

            // 차트를 업데이트
            // 차트를 업데이트
            // if (this.$refs.apexchart) {
            //     this.$refs.apexchart.updateOptions(this.chartOptions);
            //     // this.$refs.apexchart.forceUpdate();
            // }
            // if (this.$refs.bugChart) {
            //     this.$refs.bugChart.updateOptions({
            //         labels: this.label
            //     });
            // }
        },
        setTable() {
            this.tableData = this.data.table;

        },
    },
}
</script>

<style scoped>
.count-label {
    font-size: 2.25rem !important;
    font-weight: 500;
}
.count-data {
    margin-top: 20px;
    font-size: 2.5rem;
    font-weight: 600;
}
.h-80 {
    padding-top: 10px;
    height: 80%;
}
.h-90 {
    height: 90%;
}
</style>

<style>
/* 커스텀 툴팁 스타일 */
.bug-report-graph .apexcharts-tooltip {
    border-radius: 100px;
    border: 1px solid #FFF;
    background: transparent;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.20);
}
.bug-report-graph .apexcharts-tooltip-series-group.apexcharts-active {
    padding: 0 12px;
}
</style>